export default {
    required: 'Wyrażenie tej zgody jest wymagane'
};
